import { Button, Container, CssBaseline, makeStyles, TextField, Typography, Input, InputAdornment, InputLabel, IconButton, FormControl, Grid, List, ListItem, Box } from '@material-ui/core';
import { COLORS } from '../../shared/Theme';

import React, { Fragment, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { SIcon } from '../../shared/Icon';

import axios from 'axios';
import { admin as v_admin, basic, Values, SNACKBAR_TIME } from '../../request/values';

//const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	nanumSquare_regular: {
		fontFamily: 'NanumR',
	},
	background: {
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	content: {
		width: '100%',
		height: '100%',
		display: 'grid',
	},
	mainPage: {
		display: 'grid',
		gridTemplateRows: '1.5fr 5fr',
	},
	title: {
		margin: '5vh 0px 0px 35px',
		fontFamily: 'NanumR',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		display: 'flex',
		gap: '10vw',
	},
	logo: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'stretch',
		//border: 'solid white',
		margin: '5vh 0px',
		borderWidth: '0px 0px 1px 0px',
		//cursor: 'pointer',
		'& img': {
			width: '30px',
			maxHeight: '50%',
			height: '30px',
			margin: '12px 5px 0px 9%',
		},
		'& #name': {
			display: 'inline-block',
			margin: '10px 0px 0px 0px',
			width: 'calc(91% - 35px)',
			fontFamily: 'NanumR',
			fontSize: '1.5rem',
			fontWeight: 'bolder',
		},
		'& #welcome': {
			display: 'block',
			margin: '5px 0px 0px 9%',
			fontFamily: 'NanumR',
			fontSize: '1.2rem',
		},
	},
	userinfo: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'column',
		alignItems: 'center',
		border: 'none',
		borderWidth: '0px 0px 1px 0px',
		paddingBottom: '0.5vh',
		'& #name': {
			display: 'inline-block',
			fontFamily: 'NanumR',
			fontSize: '1.25rem',
			fontWeight: 'bolder',
		},
	},
	menu: {
		display: 'grid',
		border: 'none',
		borderWidth: '0px 0px 1px 0px',
		fontFamily: 'NanumR',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		'&::after': {
			content: '""',
			position: 'absolute',
			width: '0',
			height: '0',
			left: '50%',
			bottom: '0',
			borderBottom: '3px solid black',
			transition: 'width 0.3s ease, left 0.3s ease',
			WebkitTransition: 'width 0.3s ease, left 0.3s ease',
		},
		'&:hover::after': {
			width: '100%',
			left: '0',
		},
		'&:hover': {
			backgroundColor: 'transparent', // hover 배경색 제거
		},
	},
	navigator: {
		display: 'grid',
		gridTemplateColumns: '1fr 2fr',
		marginTop: '1%',
		//fontSize: '5vw',
		//backgroundColor: `${COLORS.WHITE}`,
	},
	subTitle: {
		minWidth: '10vw',
		display: 'flex',
		flexDirection: 'column',
	},
	menuOpen: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		alignItems: 'center',
		marginTop: '10px',
		gap: '10px',
		'& a': {
			margin: '5px',
			fontSize: '1rem',
			width: 'fit-content',
			height: '100%',
			cursor: 'pointer',
			textAlign: 'center',
			position: 'relative',
			'&::after': {
				content: '""',
				position: 'absolute',
				display: 'inline-block',
				width: '0',
				height: '0',
				left: '50%',
				bottom: '-5px',
				borderBottom: '2px solid black',
				transition: 'width 0.3s ease, left 0.3s ease',
				WebkitTransition: 'width 0.3s ease, left 0.3s ease',
			},
			'&:hover::after': {
				width: '100%',
				left: '0',
			},
		},
	},
	menuClose: {
		display: 'none',
	},
	form: {
		display: 'flex',
		width: '97%',
		height: '5%',
		justifyContent: 'right',
		alignItems: 'center',
		gap: '1%',
		'& input': {
			width: '15%',
			height: '80%',
			paddingLeft: '7px',
		},
		'& Button': {
			//border: 'solid 1px',
			border: 'solid gray 1px',
			height: '90%',
			//borderStyle: 'inset',
			//backgroundColor: '-webkit-control-background',
		},
	},
	classList: {},
	table: {
		display: 'grid',
		gridTemplateRows: '50px 1fr',
		width: '94%',
		height: '60vh',
		margin: '1% 3%',
		'& #title': {
			display: 'grid',
			gridTemplateColumns: '3fr 4fr 5fr 5fr 3fr 17px',
			border: 'solid',
			borderWidth: '0 0 2px 0',
			'& span': {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				'& p': {
					fontSize: '1.15rem',
					fontWeight: 'bolder',
				},
			},
		},
		'& #memberinfo': {
			overflow: 'scroll',
			overflowX: 'hidden',
			borderRadius: '0 0 0 10px',
		},
		'& ul': {
			padding: '0',
		},
		'& li': {
			border: 'solid gray',
			borderWidth: '0 0 1px 0',
		},
	},
	memberInfo: {
		display: 'grid',
		gridTemplateColumns: '3fr 4fr 5fr 5fr 3fr 17px',
		padding: '25px 0',
		backgroundColor: `${COLORS.WHITE}`,
	},
	buttonLabel: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		fontSize: '1rem',
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		lineHeight: '21px',
		bolderWidth: '1px',
	},
	blank: {
		display: 'flex',
		height: '40px',
	},
}));

type iMemberList = {
	mem_name: String;
	mem_phone: String;
	mem_email: String;
	mem_company: String;
	mem_grade: String;
};

const SERVER = basic.server;

const SubadminClassMember: React.FC<any> = (props) => {
	const classes = useStyles();
	let history = useHistory();
	const state: any = history.location.state;
	const classCode = state.code;

	const { member } = props;

	const [MemberList, setMemberList] = useState<iMemberList[]>([]);
	const [menu, setMenu] = useState<boolean>(false);
	const [targetMemberName, setTargetMemberName] = useState<any | null>();
	const [operMenu, setOperMenu] = useState<boolean>(false);

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { id, value } = e.target;
		if (id == 'targetMemberName') setTargetMemberName(value);
	};

	const searchControl = () => {
		if (targetMemberName == '') getMemberContent();
		else searchMemberContent();
	};

	const searchMemberContent = () => {
		let url = new URL(SERVER + v_admin.admin + v_admin.search_member);
		let params = {
			classCode: classCode.toString(),
			targetMemberName: targetMemberName.toString(),
		};
		url.search = new URLSearchParams(params).toString();
		axios({
			method: 'GET',
			withCredentials: true,
			//url: SERVER + v_admin.admin + v_admin.search_class,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setMemberList(data.data);
				}
			});
	};

	const getMemberContent = () => {
		let url = new URL(SERVER + v_admin.admin + v_admin.member_list);
		let params = {
			classCode: classCode.toString(),
			email: member.id.toString(),
		};
		url.search = new URLSearchParams(params).toString();
		axios({
			method: 'GET',
			withCredentials: true,
			//url: SERVER + v_admin.admin + v_admin.member_list,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					setMemberList(data.data);
				}
			});
	};

	const moveClassList = () => {
		history.push('/subAdminClassList');
	};
	const moveClassManage = () => {
		history.push('/subAdminClassManage');
	};
	const moveOperList = () => {
		history.push('/subAdminOperList');
	};

	useEffect(() => {
		getMemberContent();
	}, []);

	return (
		<div className={classes.background}>
			<CssBaseline />
			<div className={classes.content}>
				<div className={classes.mainPage}>
					<div className={classes.navigator}>
						<div className={classes.logo}>
							<img src="/images/p.webp"></img>
							<Typography id="name">플레이스타트업</Typography>
							<Typography id="welcome">{member.name}님, 환영합니다!</Typography>
						</div>
						<div className={classes.title}>
							<div
								className={classes.subTitle}
								onMouseOver={() => {
									setMenu(true);
								}}
								onMouseOut={() => {
									setMenu(false);
								}}
							>
								<Button className={classes.menu} onClick={() => moveClassList()}>
									교육
								</Button>
								<div className={menu ? classes.menuOpen : classes.menuClose}>
									<a onClick={(e) => moveClassList()}>교육 목록</a>
									<a onClick={(e) => moveClassManage()}>교육 관리 목록</a>
								</div>
							</div>
							<div
								className={classes.subTitle}
								onMouseOver={() => {
									setOperMenu(true);
								}}
								onMouseOut={() => {
									setOperMenu(false);
								}}
							>
								<Button className={classes.menu} onClick={() => moveOperList()}>
									강사
								</Button>
								<div className={operMenu ? classes.menuOpen : classes.menuClose}>
									<a onClick={(e) => moveOperList()}>강사 관리</a>
								</div>
							</div>
						</div>
					</div>
					<div className={classes.classList}>
						<div className={classes.form}>
							<input type="text" placeholder="검색할 이름을 입력해주세요." id="targetMemberName" onChange={valueChangeHandler} />
							<Button onClick={searchControl}>
								<Typography>검색</Typography>
							</Button>
						</div>
						<div className={classes.table}>
							<div id="title">
								<span>
									<Typography>이름</Typography>
								</span>
								<span>
									<Typography>전화번호</Typography>
								</span>
								<span>
									<Typography>이메일</Typography>
								</span>
								<span>
									<Typography>기업명</Typography>
								</span>
								<span>
									<Typography>직책</Typography>
								</span>
							</div>
							<List id="memberinfo">
								{MemberList != null &&
									MemberList.map((item: any, index: number) => {
										return <AppListItem index={index} name={item.member_name} phone={item.member_phone} email={item.member_email} company={item.company_name} grade={item.grade} />;
									})}
								<div className={classes.blank}></div>
							</List>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const AppListItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { index, name, phone, email, company, grade } = props;

	return (
		<ListItem id={index} className={classes.memberInfo}>
			<Box className={classes.buttonLabel}>{name}</Box>
			<Box className={classes.buttonLabel}>{phone}</Box>
			<Box className={classes.buttonLabel}>{email}</Box>
			<Box className={classes.buttonLabel}>{company}</Box>
			<Box className={classes.buttonLabel}>{grade}</Box>
		</ListItem>
	);
};

export default SubadminClassMember;
